__webpack_require__.p = "/peking/";